import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Box } from '@mui/material';
dayjs.extend(customParseFormat);

const dateFormat = "MM/DD/YYYY";
const CustomDatePicker = ({selectedDate,fromDate,handleCalendar,...props}) => {

  const formatDate = (dateString) => {
    const dateParts = dateString.split('-');
    return `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
  };

  return (
    <Box >
      <DatePicker
        value={selectedDate ? dayjs(selectedDate) : dayjs()}
        format={(value) => `${formatDate(fromDate)} - ${value.format(dateFormat)}`}
        onChange={(newValue) =>handleCalendar(newValue)}
        suffixIcon={null}
        allowClear={false}
        {...props}
      />
    </Box>
  )
}

export default CustomDatePicker